const Header = () => {
  return (
    <hgroup>
      <h2 className="main_header">Magic Paint Magazzino</h2>
    </hgroup>
  );
};
export default Header;
